import {i18n} from '@/plugins/i18n';
import {transmitDescription, transmitDescriptionStr} from '@/constants/transmitDescription';
import {transmitType, transmitTypeStr} from "@/constants/transmitType";
import DescriptionColumn from "./Description.vue";

const descriptionTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'format_balance',
        title: i18n.t('label.balance'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount_rial'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            let type = ''
            if (row.type  === 'CREDIT') {
                type = "<span class='badge badge-success'>واریز</span>"
            }
            else {
                type = "<span class='badge badge-danger'>برداشت</span>"
            }
            return type;
        },
    },
    {
        field: 'payment_date',
        title: i18n.t('label.date'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'action',
        width: 80,
        title: i18n.t('reports.actions'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
];